import { GET_SUPERVISION_SUMMARY } from './supervision.types';

export const getSupervisionSummary = (params, load) => {
    return {
        type: GET_SUPERVISION_SUMMARY,
        payload: { params, load },
    };
};

export const supervisionActions = {
    getSupervisionSummary,
};
